import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { SelectCard } from './select-card';
import { NewCard } from './new-card';
import { useTokenizedCards } from './helpers/useTokenizedCards';
import { usePaymentContext } from './PaymentContext';
import { PaymentMainUserShimmer } from './PaymentMainUserShimmer';

export const PaymentMainUser = observer(() => {
	const { hasCards, isLoading, cards } = useTokenizedCards();
	const { newCard, setNewCard } = usePaymentContext();

	useEffect(() => {
		setNewCard(!hasCards);
	}, [hasCards, setNewCard]);

	const onClickCancelNewCard = () => setNewCard(false);
	const onClickAddNewCard = () => setNewCard(true);

	if (isLoading) {
		return <PaymentMainUserShimmer />;
	}

	const shouldShowNewCardForm = newCard || !hasCards;

	return shouldShowNewCardForm ? (
		<NewCard
			canBeSaved
			canBeCanceled={hasCards}
			onClickCancel={onClickCancelNewCard}
		/>
	) : (
		<SelectCard cards={cards} onClickAddNewCard={onClickAddNewCard} />
	);
});
